<div class="bdo-container--single re-mb-60" [attr.data-qa] ="dataQa">
    <a [routerLink]="routerUrl" class="bdo-nolink re-group">
      <div class="nobutton bold bdo-space--bottom">
        <div class="re-w-75 re-h-75 re-p-15 re-bg-primary re-inline-block re-mr-30">
          <svg-icon class="re-w-45 re-h-45 re-inline-block re-text-white" src="{{ 'general.img.plusCircle' | translate }}"></svg-icon>
        </div>
        <span class="group-hover:re-text-primary group-focus:re-text-primary">{{ text }}</span>
      </div>
    </a>
  </div>